// Troca de senha.
//
// A rota é PUT /caixas/{uuid}/senha, a mesma que um administrador usa. Quem
// decide se a pessoa pode trocar a senha DAQUELA caixa é o servidor — a
// interface não sabe e não precisa saber.

import { useState } from "react";
import { useMutation } from "@tanstack/react-query";

import { caixas } from "../api/admin";
import { explicar } from "../api/problema";
import { Secao } from "./DoisFatores";

export function Senha({ caixaUUID }: { caixaUUID: string }) {
  const [nova, setNova] = useState("");
  const [repetida, setRepetida] = useState("");
  const [erro, setErro] = useState("");
  const [pronto, setPronto] = useState(false);

  const trocar = useMutation({
    mutationFn: () => caixas.trocarSenha(caixaUUID, nova),
    onSuccess: () => {
      setNova("");
      setRepetida("");
      setErro("");
      setPronto(true);
    },
    onError: (e) => {
      setPronto(false);
      setErro(explicar(e));
    },
  });

  // A conferência acontece aqui porque o servidor não tem como fazê-la: ele
  // recebe uma senha só. É o único caso em que validar no cliente não é
  // duplicar o que o servidor já faz.
  const divergem = repetida.length > 0 && nova !== repetida;

  return (
    <Secao titulo="Senha da conta" icone="Lock">
      <p className="text-sm text-tinta-media">
        Trocar a senha <strong>não</strong> encerra as senhas de aplicativo nem
        as outras sessões — cada uma se revoga na sua seção.
      </p>

      <div className="mt-4 grid max-w-md gap-3">
        <label className="text-sm">
          <span className="text-tinta-fraca">Nova senha</span>
          <input
            type="password"
            value={nova}
            onChange={(e) => {
              setNova(e.target.value);
              setPronto(false);
            }}
            autoComplete="new-password"
            className="mt-1 w-full rounded-lg border border-linha px-3 py-2 text-sm"
          />
        </label>
        <label className="text-sm">
          <span className="text-tinta-fraca">Repita a nova senha</span>
          <input
            type="password"
            value={repetida}
            onChange={(e) => setRepetida(e.target.value)}
            autoComplete="new-password"
            aria-invalid={divergem}
            className={`mt-1 w-full rounded-lg border px-3 py-2 text-sm ${
              divergem ? "border-perigo" : "border-linha"
            }`}
          />
          {divergem && <span className="text-xs text-perigo">As duas não conferem.</span>}
        </label>

        <div className="flex items-center gap-3">
          <button
            onClick={() => trocar.mutate()}
            disabled={!nova || divergem || !repetida || trocar.isPending}
            className="rounded-lg bg-acao px-4 py-2 text-sm text-white disabled:opacity-60"
          >
            {trocar.isPending ? "…" : "Trocar senha"}
          </button>
          {pronto && <span className="text-sm text-acao">Senha trocada.</span>}
        </div>
      </div>

      {erro && <p className="mt-3 text-sm text-perigo">{erro}</p>}
    </Secao>
  );
}
